import { formatBaseCurrency } from '@infinitro/config';
export function toCamelCase(str) {
    if (!str)
        return '';
    return str
        .toLowerCase()
        .split(/[\s-_]+/)
        .map((word, index) => index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
}
export function toTitleCase(str) {
    if (!str)
        return '';
    return str
        .toLowerCase()
        .split(/[\s-_]+/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
export const formatNumber = (unformattedQty, isCurrency = false, includeDecimals = true, _currencyType = 'USD', isMultiplier = false) => {
    const value = Number(unformattedQty);
    if (isNaN(value))
        return '';
    if (isCurrency) {
        return formatBaseCurrency(Number(unformattedQty), false);
    }
    const options = {
        minimumFractionDigits: includeDecimals ? 2 : 0,
        maximumFractionDigits: includeDecimals ? 6 : 0,
        style: 'decimal'
    };
    return isMultiplier
        ? value.toLocaleString('en-US', options).concat('x')
        : value.toLocaleString('en-US', options);
};
export const getPercentage = (current, total) => {
    const curr = Number(current);
    const tot = Number(total);
    if (!isFinite(curr) || !isFinite(tot) || tot === 0) {
        return 0;
    }
    return Math.floor((curr / tot) * 10000) / 100;
};
export const isSameOrFutureDate = (compareDate, includeCurrentDate = true) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const rDate = new Date(compareDate);
    rDate.setHours(0, 0, 0, 0);
    return includeCurrentDate ? rDate >= today : rDate > today;
};
export function formatWager(wager) {
    if (wager >= 1000000) {
        return (wager / 1000000).toFixed(1) + 'M';
    }
    else if (wager >= 1000) {
        return (wager / 1000).toFixed(1) + 'k';
    }
    else {
        return wager.toString();
    }
}
export const getRandomValueFromArray = (array) => array[Math.floor(Math.random() * array.length)];
